export default __webpack_public_path__ + "static/media/gasag_s2.9d0cf872.png";